<div class="dropdown-wrapper-1 relative w-full" [class.opacity-50]="disabled">
  <div
    class="flex items-center justify-between w-full h-11 px-3 py-2 dark:text-white rounded-lg bg-white dark:bg-[#1D1D1F] cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
    [ngClass]="[dropdownTriggerClass, customStyles, borderClass]" [class.cursor-not-allowed]="disabled" (click)="toggleDropdown()">
    <span class="truncate" [ngClass]="selectedItem ? (searchInputClass || 'text-[#000000] dark:text-textDark') : placeholderClass">
      @if (selectedItem?.iconClass) {
      <i class="{{ selectedItem?.iconClass }} mr-2"></i>
      }
      {{ selectedItem ? selectedItem.label : placeholder }}
    </span>

    <div class="flex items-center space-x-1">
      <!-- Clear button -->
      @if (clearable && selectedItem && !disabled && showClearIcon) {
      <button *ngIf="selectedItem" type="button" class="text-gray-400 hover:text-gray-600 focus:outline-none"
        (click)="clearSelection($event)">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
      }

      <!-- Dropdown arrow — show when no selection, OR when showClearIcon is false -->
      <i *ngIf="!isOpen && (!selectedItem || !showClearIcon)" class="fa-solid fa-angle-down text-gray-400"></i>
      <i *ngIf="isOpen && (!selectedItem || !showClearIcon)" class="fa-solid fa-angle-up text-gray-400"></i>

    </div>
  </div>

  <!-- Dropdown menu -->
  @if (isOpen && !disabled) {
  <div
    class="absolute z-50 w-full mt-1 bg-white border dark:bg-[#292929] dark:text-textDark border-gray-200 dark:border-[#828282] rounded-xl shadow-lg max-h-60 overflow-auto {{ dropdownMenuClass }}">
    <!-- Search input -->
    <div
      class="sticky top-0 bg-white dark:bg-[#292929] dark:text-textDark p-2 border-b border-gray-200 dark:border-[#828282]">
      <div class="relative w-full">
        <input type="text" [placeholder]="searchPlaceholder" [value]="searchTerm" (input)="onSearchInput($event)"
          [ngClass]="searchInputClass"
          class="w-full px-3 py-2 pr-10 border text-lg dark:bg-[#292929] dark:text-textDark border-gray-300 dark:border-[#828282] rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          autofocus />
        <i
          class="fa-solid fa-magnifying-glass absolute text-lg right-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
      </div>
    </div>

    <!-- Options list -->
    <div class="py-1">
      @if (filteredItems.length === 0) {
      <div class="px-3 py-2 text-sm text-gray-500 text-center">
        No options found
      </div>
      } @else {
      @for (item of filteredItems; track item.value) {
      <button type="button"
        class="w-full text-left px-3 py-2 text-md hover:bg-gray-100 dark:hover:bg-[#474747] focus:outline-none focus:bg-gray-100 transition-colors duration-150"
        [class.text-gray-400.cursor-not-allowed]="item.disabled"
        [class.cursor-not-allowed]="item.disabled && item.iconClass"
        [class.text-blue-700]="selectedItem?.value === item.value && showSelected"
        [class.hover:bg-blue-100]="selectedItem?.value === item.value && showSelected" (click)="selectItem(item)"
        [disabled]="item.disabled">
        @if (item.iconClass) {
        <i class="{{ item.iconClass }} mr-2"></i>
        }
        <span [style.color]="item.disabled && item.iconClass ? '#4B5563' : null">{{ item.label }}</span>
        @if (selectedItem?.value === item.value && showSelected) {
        <span class="ml-2 text-blue-600">✓</span>
        }
      </button>
      }
      }
    </div>
  </div>
  }
</div>